import gsap from "gsap";

export class Search {
  constructor() {
    this.searchButton = document.querySelector(".search-button");
    this.search = document.querySelector(".search");
    this.searchInput = document.querySelector(".search__input");
    this.onOutsideClick = null;

    this.init();
  }

  init() {
    if (!this.searchButton || !this.search || !this.searchInput) return;

    this.onOutsideClick = this.handleOutsideClick.bind(this);
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Toggle search visibility
    this.searchButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.toggleSearch();
      e.stopPropagation();
    });

    // Ensure that clicks on the search input do not close the search
    this.searchInput.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  }

  toggleSearch() {
    // Check if search is currently hidden
    if (this.search.getAttribute("aria-hidden") === "true") {
      this.openSearch();
    } else {
      this.closeSearch();
    }
  }

  openSearch() {
    this.search.setAttribute("aria-hidden", "false");
    document.addEventListener("click", this.onOutsideClick);
    this.searchInput.focus();
  }

  closeSearch() {
    this.search.setAttribute("aria-hidden", "true");
    document.removeEventListener("click", this.onOutsideClick);
  }

  handleOutsideClick(e) {
    if (!this.searchInput.contains(e.target)) {
      this.closeSearch();
    }
  }
}
